export const FIXED_LEVERAGE_MODE = "fixed";
export const SELECTABLE_LEVERAGE_MODE = "selectable";

export function normalizeAllowedLeverages(values) {
  if (!Array.isArray(values)) return [];
  const seen = new Set();
  return values.reduce((result, value) => {
    const leverage = Number(value);
    if (!Number.isInteger(leverage) || leverage < 1 || seen.has(leverage)) return result;
    seen.add(leverage);
    result.push(leverage);
    return result;
  }, []).sort((a, b) => a - b);
}

export function formatLeverage(value) {
  const leverage = Number(value);
  return Number.isInteger(leverage) && leverage > 0 ? `${leverage}x` : "-";
}

export function resolveAccountLeverage(account, selectedLeverage) {
  if (account?.leverage_mode === FIXED_LEVERAGE_MODE) {
    const leverage = Number(account?.leverage);
    return Number.isInteger(leverage) && leverage > 0 ? leverage : null;
  }
  if (account?.leverage_mode === SELECTABLE_LEVERAGE_MODE) {
    const leverage = Number(selectedLeverage);
    return normalizeAllowedLeverages(account?.allowed_leverages).includes(leverage) ? leverage : null;
  }
  return null;
}

export function leverageStorageKey(accountCode) {
  return `trade_leverage_${String(accountCode ?? "")}`;
}
